// @ts-nocheck
/**
 * ツインキーバフタイプ定義
 *
 * 仕様書: twin_key_status_skill_system_v1.md
 * 設計書: twin_key_phase2_design.md
 */

/**
 * バフタイプ（7種類）
 */
export const BUFF_TYPES = {
  ATK_UP: 'ATK_UP',           // 攻撃↑ - 攻撃力+20%
  DEF_UP: 'DEF_UP',           // 防御↑ - 防御+20
  SPD_UP: 'SPD_UP',           // 速度↑ - 速度+20
  REGEN: 'REGEN',             // 再生 - HP3%/ターン回復
  CRIT_UP: 'CRIT_UP',         // クリティカル↑ - クリ率+15%
  EVASION_UP: 'EVASION_UP',   // 回避↑ - 被弾時20%で回避
  COUNTER: 'COUNTER',         // 反撃 - 被弾時に反撃（攻撃力50%）
};

/**
 * バフメタデータ
 */
export const BUFF_META = {
  [BUFF_TYPES.ATK_UP]: {
    name: '攻撃↑',
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    description: '攻撃力+20%（スタックで増加）',
    cancelsWith: 'ATK_DOWN', // 相殺対象
  },
  [BUFF_TYPES.DEF_UP]: {
    name: '防御↑',
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    description: '防御+20（スタックで増加）',
    cancelsWith: 'DEF_DOWN',
  },
  [BUFF_TYPES.SPD_UP]: {
    name: '速度↑',
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    description: '速度+20（スタックで増加）',
    cancelsWith: 'SPD_DOWN',
  },
  [BUFF_TYPES.REGEN]: {
    name: '再生',
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    description: 'HP3%/ターン回復（スタックで増加）',
    cancelsWith: null,
  },
  [BUFF_TYPES.CRIT_UP]: {
    name: 'クリティカル↑',
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    description: 'クリティカル率+15%（スタックで増加）',
    cancelsWith: null,
  },
  [BUFF_TYPES.EVASION_UP]: {
    name: '回避↑',
    defaultDuration: 3,
    stackable: true,
    maxStack: 3,
    description: '被弾時20%で回避（スタックで増加）',
    cancelsWith: null,
  },
  [BUFF_TYPES.COUNTER]: {
    name: '反撃',
    defaultDuration: 3,
    stackable: false,
    maxStack: 1,
    description: '被弾時に反撃（攻撃力50%）',
    cancelsWith: null,
  },
};

/**
 * バフと状態異常の相殺マッピング
 */
export const BUFF_DEBUFF_CANCEL_MAP = {
  [BUFF_TYPES.ATK_UP]: 'ATK_DOWN',
  [BUFF_TYPES.DEF_UP]: 'DEF_DOWN',
  [BUFF_TYPES.SPD_UP]: 'SPD_DOWN',
};

/**
 * 状態異常とバフの相殺マッピング（逆引き）
 */
export const DEBUFF_BUFF_CANCEL_MAP = {
  ATK_DOWN: BUFF_TYPES.ATK_UP,
  DEF_DOWN: BUFF_TYPES.DEF_UP,
  SPD_DOWN: BUFF_TYPES.SPD_UP,
};

/**
 * スタック効果量
 */
export const BUFF_STACK_EFFECTS = {
  [BUFF_TYPES.ATK_UP]: {
    1: { atkMultiplier: 1.20 },    // +20%
    2: { atkMultiplier: 1.40 },    // +40%
    3: { atkMultiplier: 1.60 },    // +60%
  },
  [BUFF_TYPES.DEF_UP]: {
    1: { def: 20 },
    2: { def: 40 },
    3: { def: 60 },
  },
  [BUFF_TYPES.SPD_UP]: {
    1: { speed: 20 },
    2: { speed: 40 },
    3: { speed: 60 },
  },
  [BUFF_TYPES.REGEN]: {
    1: { hpPercent: 0.03 },    // 3%
    2: { hpPercent: 0.06 },    // 6%
    3: { hpPercent: 0.09 },    // 9%
  },
  [BUFF_TYPES.CRIT_UP]: {
    1: { critRate: 0.15 },    // +15%
    2: { critRate: 0.30 },    // +30%
    3: { critRate: 0.45 },    // +45%
  },
  [BUFF_TYPES.EVASION_UP]: {
    1: { evasion: 0.20 },     // 20%
    2: { evasion: 0.40 },     // 40%
    3: { evasion: 0.60 },     // 60%
  },
  [BUFF_TYPES.COUNTER]: {
    1: { counterRate: 1.00, counterDamage: 0.50 },  // 100%反撃、攻撃力50%
  },
};

/**
 * バフアイコン
 */
export const BUFF_ICONS = {
  [BUFF_TYPES.ATK_UP]: '⚔️⬆️',
  [BUFF_TYPES.DEF_UP]: '🛡️⬆️',
  [BUFF_TYPES.SPD_UP]: '💨',
  [BUFF_TYPES.REGEN]: '💚',
  [BUFF_TYPES.CRIT_UP]: '💥',
  [BUFF_TYPES.EVASION_UP]: '👻',
  [BUFF_TYPES.COUNTER]: '🔄',
};

/**
 * ヘルパー関数: バフメタデータ取得
 */
export const getBuffMeta = (type) => BUFF_META[type] || null;

/**
 * ヘルパー関数: バフ名取得
 */
export const getBuffName = (type) => BUFF_META[type]?.name || type;

/**
 * ヘルパー関数: バフアイコン取得
 */
export const getBuffIcon = (type) => BUFF_ICONS[type] || '✨';

/**
 * ヘルパー関数: スタック効果取得
 */
export const getBuffStackEffect = (type, stack) => {
  const effects = BUFF_STACK_EFFECTS[type];
  if (!effects) return null;
  return effects[Math.min(stack, 3)] || effects[1];
};

/**
 * ヘルパー関数: 相殺対象取得
 */
export const getCancelTarget = (buffType) => {
  return BUFF_DEBUFF_CANCEL_MAP[buffType] || null;
};

/**
 * ヘルパー関数: 相殺バフ取得（状態異常から）
 */
export const getCancelBuff = (debuffType) => {
  return DEBUFF_BUFF_CANCEL_MAP[debuffType] || null;
};
